module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/zawieszenie-973c0fcf.png";